// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rights-settings .rights-settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}
.rights-settings .rights-settings-grid .rights-settings-item {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.rights-settings .rights-settings-grid .rights-settings-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}
.rights-settings .rights-settings-grid .rights-settings-item:hover::before {
  left: 0;
}
.rights-settings .rights-settings-grid .rights-settings-item label {
  display: block;
  font-weight: 600;
  font-size: 1rem;
  color: #334155;
  margin-bottom: 1rem;
  text-transform: capitalize;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 2;
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox] {
  appearance: none;
  width: 60px;
  height: 32px;
  background: #cbd5e1;
  border-radius: 50px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]::before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:checked {
  background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:checked::before {
  transform: translateX(28px);
}
.rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:focus {
  outline: none;
}
.rights-settings .rights-settings-save-btn {
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  display: block;
  padding: 1rem;
  background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
}
.rights-settings .rights-settings-save-btn:disabled {
  position: relative;
}
@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
@media (max-width: 768px) {
  .rights-settings .rights-settings-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .rights-settings .rights-settings-grid .rights-settings-item {
    padding: 1.25rem;
  }
  .rights-settings .rights-settings-title {
    font-size: 1.5rem;
  }
}
@media (max-width: 480px) {
  .rights-settings .rights-settings-grid .rights-settings-item {
    padding: 1rem;
  }
  .rights-settings .rights-settings-grid .rights-settings-item label {
    font-size: 0.9rem;
  }
  .rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox] {
    width: 50px;
    height: 28px;
  }
  .rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]::before {
    width: 20px;
    height: 20px;
    top: 4px;
    left: 4px;
  }
  .rights-settings .rights-settings-grid .rights-settings-item input[type=checkbox]:checked::before {
    transform: translateX(22px);
  }
  .rights-settings .rights-settings-save-btn {
    font-size: 1rem;
    padding: 0.875rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/VisibilitySettings/VisibilitySettings.scss"],"names":[],"mappings":"AAYE;EACE,aAAA;EACA,2DAAA;EACA,WAAA;EACA,mBAAA;AAXJ;AAaI;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAXN;AAaM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gGAAA;EACA,kDAAA;EACA,UAAA;AAXR;AAmBQ;EACE,OAAA;AAjBV;AAqBM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AAnBR;AAuBM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,UAAA;AArBR;AAuBQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iDAAA;AArBV;AAyBQ;EACE,0EAAA;AAvBV;AAyBU;EACE,2BAAA;AAvBZ;AAoCQ;EACE,aAAA;AAlCV;AAyCE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,0EAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAvCJ;AA2CE;EACE,kBAAA;AAzCJ;AAyDE;EACE;IAAK,6CAAA;EAtDP;EAuDE;IAAO,+CAAA;EApDT;AACF;AAsDE;EACE;IACE,0BAAA;IACA,SAAA;EApDJ;EAsDI;IACE,gBAAA;EApDN;EAwDE;IACE,iBAAA;EAtDJ;AACF;AAyDE;EAEI;IACE,aAAA;EAxDN;EA0DM;IACE,iBAAA;EAxDR;EA2DM;IACE,WAAA;IACA,YAAA;EAzDR;EA2DQ;IACE,WAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EAzDV;EA4DQ;IACE,2BAAA;EA1DV;EAgEE;IACE,eAAA;IACA,wBAAA;EA9DJ;AACF","sourcesContent":["\r\n.rights-settings {\r\n\r\n  // .rights-settings-title {\r\n  //   font-size: 1.75rem;\r\n  //   font-weight: 600;\r\n  //   color: #1e293b;\r\n  //   margin-bottom: 2rem;\r\n  //   text-align: center;\r\n  //   position: relative;\r\n  // }\r\n\r\n  .rights-settings-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n    gap: 1.5rem;\r\n    margin-bottom: 3rem;\r\n\r\n    .rights-settings-item {\r\n      background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\r\n      border: 2px solid #e2e8f0;\r\n      border-radius: 16px;\r\n      padding: 1.5rem;\r\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n      position: relative;\r\n      overflow: hidden;\r\n\r\n      &::before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        left: -100%;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\r\n        transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n        z-index: 1;\r\n      }\r\n\r\n      &:hover {\r\n        // transform: translateY(-4px);\r\n        // box-shadow: 0 15px 30px rgba(102, 126, 234, 0.15);\r\n        // border-color: #667eea;\r\n\r\n        &::before {\r\n          left: 0;\r\n        }\r\n      }\r\n\r\n      label {\r\n        display: block;\r\n        font-weight: 600;\r\n        font-size: 1rem;\r\n        color: #334155;\r\n        margin-bottom: 1rem;\r\n        text-transform: capitalize;\r\n        letter-spacing: 0.5px;\r\n        position: relative;\r\n        z-index: 2;\r\n      }\r\n\r\n      // Custom toggle switch\r\n      input[type=\"checkbox\"] {\r\n        appearance: none;\r\n        width: 60px;\r\n        height: 32px;\r\n        background: #cbd5e1;\r\n        border-radius: 50px;\r\n        position: relative;\r\n        cursor: pointer;\r\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n        z-index: 2;\r\n\r\n        &::before {\r\n          content: '';\r\n          position: absolute;\r\n          top: 4px;\r\n          left: 4px;\r\n          width: 24px;\r\n          height: 24px;\r\n          background: white;\r\n          border-radius: 50%;\r\n          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n          // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n        }\r\n\r\n        &:checked {\r\n          background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);\r\n          \r\n          &::before {\r\n            transform: translateX(28px);\r\n            // box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\r\n          }\r\n        }\r\n\r\n        // &:hover {\r\n        //   transform: scale(1.05);\r\n          \r\n        //   // &::before {\r\n        //   //   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n        //   // }\r\n        // }\r\n\r\n        &:focus {\r\n          outline: none;\r\n          // box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .rights-settings-save-btn {\r\n    width: 100%;\r\n    max-width: 250px;\r\n    margin: 0 auto;\r\n    display: block;\r\n    padding: 1rem;\r\n    background: linear-gradient(135deg, #667eea 0%, var(--primary-color) 100%);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    position: relative;\r\n    overflow: hidden;\r\n    letter-spacing: 0.5px;\r\n    \r\n  }\r\n\r\n  .rights-settings-save-btn:disabled {\r\n    position: relative;\r\n    // &::after {\r\n    //   content: '';\r\n    //   position: absolute;\r\n    //   top: 50%;\r\n    //   left: 50%;\r\n    //   transform: translate(-50%, -50%);\r\n    //   width: 20px;\r\n    //   height: 20px;\r\n    //   border: 2px solid rgba(255, 255, 255, 0.3);\r\n    //   border-top: 2px solid white;\r\n    //   border-radius: 50%;\r\n    //   animation: spin 1s linear infinite;\r\n    // }\r\n  }\r\n\r\n  @keyframes spin {\r\n    0% { transform: translate(-50%, -50%) rotate(0deg); }\r\n    100% { transform: translate(-50%, -50%) rotate(360deg); }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .rights-settings-grid {\r\n      grid-template-columns: 1fr;\r\n      gap: 1rem;\r\n\r\n      .rights-settings-item {\r\n        padding: 1.25rem;\r\n      }\r\n    }\r\n\r\n    .rights-settings-title {\r\n      font-size: 1.5rem;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    .rights-settings-grid {\r\n      .rights-settings-item {\r\n        padding: 1rem;\r\n        \r\n        label {\r\n          font-size: 0.9rem;\r\n        }\r\n\r\n        input[type=\"checkbox\"] {\r\n          width: 50px;\r\n          height: 28px;\r\n\r\n          &::before {\r\n            width: 20px;\r\n            height: 20px;\r\n            top: 4px;\r\n            left: 4px;\r\n          }\r\n\r\n          &:checked::before {\r\n            transform: translateX(22px);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .rights-settings-save-btn {\r\n      font-size: 1rem;\r\n      padding: 0.875rem 1.5rem;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
